import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const makeTicketClose = createAsyncThunk("makeTicketClose", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`desk/ticket/cancel?id=${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const TicketCloseSlice = createSlice({
	name: "TicketCloseSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(makeTicketClose.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(makeTicketClose.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(makeTicketClose.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default TicketCloseSlice.reducer;
